import styled from 'styled-components';
import Styled from '/imports/ui/components/settings/submenus/styles';

const Title = styled(Styled.Title)``;

const SubTitle = styled(Styled.SubTitle)``;

const Form = styled(Styled.Form)``;

const Row = styled(Styled.Row)``;

const Col = styled(Styled.Col)``;

const FormElement = styled(Styled.FormElement)``;

const FormElementRight = styled(Styled.FormElementRight)``;

const FormElementCenter = styled(Styled.FormElementCenter)``;

const Label = styled(Styled.Label)``;

const ColHeading = styled(Styled.Col)`
  display: block;
  text-align: center;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export default {
  Title,
  SubTitle,
  Form,
  Row,
  Col,
  FormElement,
  FormElementRight,
  FormElementCenter,
  Label,
  ColHeading,
};
